export class BatchUpdateLlgPoliciesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "updates",
            "baseName": "updates",
            "type": "Array<BatchUpdateLlgPolicyItem>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchUpdateLlgPoliciesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
